import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './olf-learning-domain.reducer';

export const selectOlfLearningDomainState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectOlfLearningDomainState, (state: State) => state.error);

export const getLoaded = createSelector(selectOlfLearningDomainState, (state: State) => state.loaded);

export const getAll = createSelector(selectOlfLearningDomainState, selectAll);

export const getCount = createSelector(selectOlfLearningDomainState, selectTotal);

export const getIds = createSelector(selectOlfLearningDomainState, selectIds);

export const getAllEntities = createSelector(selectOlfLearningDomainState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * olfLearningDomain$: OlfLearningDomainInterface[] = this.store.pipe(
    select(OlfLearningDomainQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectOlfLearningDomainState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * olfLearningDomain$: OlfLearningDomainInterface = this.store.pipe(
    select(OlfLearningDomainQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectOlfLearningDomainState,
  (state: State, props: { id: number }) => state.entities[props.id]
);
